import { getPlural } from 'lib/string/pluralize'
import type { IntlShape } from 'react-intl'

export default (partnership: App.Partnership, intl: IntlShape): string => {
  return intl.formatMessage(
    {
      id: 'YRr1_kVOjuvXLjbgTJnS',
      defaultMessage: '{rewardEarn} {rewardProgramName} {rewardEarn, plural, one {{bonusUnitSingular}} other {{bonusUnitPlural}}} per {rewardPer}',
      description: 'Partnership reward message showing bonus units earned per spending amount',
    },
    {
      rewardEarn: partnership.rewardEarn,
      rewardProgramName: partnership.rewardProgramName,
      bonusUnitSingular: partnership.bonusUnit,
      bonusUnitPlural: getPlural(partnership.bonusUnit),
      rewardPer: partnership.rewardPer,
    },
  )
}
